import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	ClientPortfolioPaymentFrequencyEnum,
	type PortfolioListItemResponseDTO,
	type PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CurrencyAmount } from "web_myplann/Portfolio/Components/Redesign/ListItem/CurrencyAmount";
import { PerformanceBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/PerformanceBadge";
import { isLoanDomain } from "web_myplann/Portfolio/Helpers/isLoanDomain";
import { roundNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	data: PortfolioListItemResponseDTO;
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const PortfolioRowTrailing: FC<Props> = ({ data, summaryData }) => {
	const { t } = useResource();

	const summary = summaryData?.find((item) => item.id === data.id)?.summary;
	const value =
		summary?.totalValue === undefined
			? null
			: roundNumber(summary.totalValue, 0);
	const currencySign = summary
		? (t(Resources.PortfolioDetail.SharedLabels.Currency[summary.currency]) ??
			t(Resources.Common.CurrencySign))
		: t(Resources.Common.CurrencySign);

	const installment =
		data.installment === null || data.installment === undefined
			? null
			: roundNumber(data.installment, 0);
	const paymentFrequency = data.paymentFrequency;
	const installmentSuffix =
		paymentFrequency &&
		paymentFrequency !== ClientPortfolioPaymentFrequencyEnum.None
			? `/${t(Resources.Portfolio.List.Redesign.PaymentFrequencyShort[paymentFrequency])}`
			: undefined;

	return (
		<Stack alignItems="flex-end" gap={0.25}>
			<CurrencyAmount value={value} currencySign={currencySign} />
			{isLoanDomain(data.domain ?? undefined) ? (
				<CurrencyAmount
					value={installment}
					currencySign={data.currencySign ?? currencySign}
					variant={value === null ? "bodyStrong" : "bodyMedium"}
					suffix={installmentSuffix}
				/>
			) : (
				<PerformanceBadge percent={summary?.totalEvaluationPercent ?? null} />
			)}
		</Stack>
	);
};
